// src/services/fieldConfigurationService.js
export const createFieldSchema = (baseConfig) => ({
  // Field identification
  name: baseConfig.name,
  type: baseConfig.type || 'text',
  
  // Display properties
  label: baseConfig.label,
  placeholder: baseConfig.placeholder,
  description: baseConfig.description,
  
  // Validation
  required: baseConfig.required || false,
  validation: {
    min: baseConfig.min,
    max: baseConfig.max,
    pattern: baseConfig.pattern,
    custom: baseConfig.customValidation,
    ...baseConfig.validation
  },
  
  // Template adaptation
  templateVariants: baseConfig.templateVariants || {},
  conditional: baseConfig.conditional, // Show/hide based on other field values
  
  // Accessibility
  ariaLabel: baseConfig.ariaLabel,
  helpText: baseConfig.helpText,
  
  // Styling & behavior
  className: baseConfig.className,
  disabled: baseConfig.disabled,
  readonly: baseConfig.readonly,
  
  // Type-specific props
  ...baseConfig.typeSpecific
});

// Example usage for different templates
export const TEMPLATE_FIELD_CONFIGS = {
  institution: {
    hero: [
      createFieldSchema({
        name: 'heading',
        type: 'text',
        label: 'Institution Name',
        required: true,
        placeholder: 'Enter your institution name'
      }),
      createFieldSchema({
        name: 'accreditation',
        type: 'list',
        label: 'Accreditations',
        itemTemplate: {
          name: { type: 'text', label: 'Accreditation Body' },
          level: { type: 'select', options: [
            { value: 'national', label: 'National' },
            { value: 'international', label: 'International' }
          ]}
        }
      })
    ]
  },
  
  business: {
    hero: [
      createFieldSchema({
        name: 'heading',
        type: 'text',
        label: 'Company Name',
        required: true
      }),
      createFieldSchema({
        name: 'revenue',
        type: 'currency',
        label: 'Annual Revenue',
        templateVariants: {
          public_company: { required: true },
          private_company: { required: false }
        }
      })
    ]
  }
};